import BatchProductListActionItem from './BatchProductListActionItem'

export default BatchProductListActionItem
